/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerFinePrints
 */
export interface CustomerFinePrints {
    /**
     * 
     * @type {string}
     * @memberof CustomerFinePrints
     */
    imprint?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerFinePrints
     */
    uploadedDataPrivacyPdf?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerFinePrints
     */
    uploadedDataPrivacyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerFinePrints
     */
    uploadedTermsUsagePdf?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerFinePrints
     */
    uploadedTermsUsageName?: string;
}

/**
 * Check if a given object implements the CustomerFinePrints interface.
 */
export function instanceOfCustomerFinePrints(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerFinePrintsFromJSON(json: any): CustomerFinePrints {
    return CustomerFinePrintsFromJSONTyped(json, false);
}

export function CustomerFinePrintsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerFinePrints {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imprint': !exists(json, 'imprint') ? undefined : json['imprint'],
        'uploadedDataPrivacyPdf': !exists(json, 'uploadedDataPrivacyPdf') ? undefined : json['uploadedDataPrivacyPdf'],
        'uploadedDataPrivacyName': !exists(json, 'uploadedDataPrivacyName') ? undefined : json['uploadedDataPrivacyName'],
        'uploadedTermsUsagePdf': !exists(json, 'uploadedTermsUsagePdf') ? undefined : json['uploadedTermsUsagePdf'],
        'uploadedTermsUsageName': !exists(json, 'uploadedTermsUsageName') ? undefined : json['uploadedTermsUsageName'],
    };
}

export function CustomerFinePrintsToJSON(value?: CustomerFinePrints | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imprint': value.imprint,
        'uploadedDataPrivacyPdf': value.uploadedDataPrivacyPdf,
        'uploadedDataPrivacyName': value.uploadedDataPrivacyName,
        'uploadedTermsUsagePdf': value.uploadedTermsUsagePdf,
        'uploadedTermsUsageName': value.uploadedTermsUsageName,
    };
}

